module.exports = __webpack_public_path__ + "img/InsertEmoticonOutlined.7dc10744.svg";